import api from './api';
import { Client, CreateClientRequest, UpdateClientRequest } from '../types';

export const clientService = {
  getAll: async (): Promise<Client[]> => {
    const response = await api.get('/clients');
    return response.data;
  },

  getById: async (id: number): Promise<Client> => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  create: async (data: CreateClientRequest): Promise<Client> => {
    const response = await api.post('/clients', data);
    return response.data;
  },

  update: async (id: number, data: UpdateClientRequest): Promise<Client> => {
    const response = await api.put(`/clients/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/clients/${id}`);
  },
};

/**
 * Baut die Empfänger-Anschrift (mehrzeilig) aus den Stammdaten eines Kunden.
 * Reihenfolge: Firma, Ansprechpartner, Straße, PLZ + Ort, Land.
 */
export const composeRecipientAddress = (client: Client): string => {
  const cityLine = [client.addressZip, client.addressCity].filter(Boolean).join(' ').trim();
  return [
    client.name,
    client.contactPerson,
    client.addressStreet,
    cityLine || null,
    client.addressCountry,
  ]
    .filter((line) => line && line.trim())
    .join('\n');
};

export default clientService;
